(function() {
    // Configura Fancybox para que el botón de cierre siempre esté visible
    $.fancybox.defaults.buttons = ['close'];
    $.fancybox.defaults.hideScrollbar = false;

    // Array para guardar las instancias de los players
    let customPlayers = [];
    let customCurrentPlayerIndex = null;

    function initializeYouTubePlayers() {
        const customHeaders = document.querySelectorAll('.video');

        customHeaders.forEach((header, index) => {
            const customBgVideoID = header.getAttribute('data-video');
            const customPlayerElement = header.querySelector('.custom-yt-player');
            const customVideoOverlay = header.querySelector('.video__overlay');
            const customPlayButton = header.querySelector('.video__controls-play');
            const customPauseButton = header.querySelector('.video__controls-pause');
            const customFullscreenButton = header.querySelector('.video__controls-fullscreen');

            customPlayers[index] = new YT.Player(customPlayerElement, {
                height: '100%',
                width: '100%',
                videoId: customBgVideoID,
                playerVars: {
                    autoplay: 1, // 🔹 Autoplay activado
                    mute: 1,     // 🔹 Arranca en silencio
                    modestbranding: 1,
                    rel: 0,
                    showinfo: 0,
                    controls: 0,
                    disablekb: 1,
                    enablejsapi: 1,
                    iv_load_policy: 3,
                    loop: 1,
                    playlist: customBgVideoID
                },
                events: {
                    'onReady': function(event) {
                        // 🔹 Forzar mute y reproducción
                        event.target.mute();
                        event.target.playVideo();

                        customPlayButton.addEventListener('click', () => {
                            if (customCurrentPlayerIndex !== null && customCurrentPlayerIndex !== index) {
                                customPlayers[customCurrentPlayerIndex].pauseVideo();

                                const customPreviousPlayButton = customHeaders[customCurrentPlayerIndex].querySelector('.video__controls-play');
                                const customPreviousPauseButton = customHeaders[customCurrentPlayerIndex].querySelector('.video__controls-pause');
                                customPreviousPlayButton.style.display = 'inline-block';
                                customPreviousPauseButton.style.display = 'none';
                            }

                            customPlayers[index].playVideo();
                            customPlayButton.style.display = 'none';
                            customPauseButton.style.display = 'inline-block';
                            customCurrentPlayerIndex = index;
                        });

                        customPauseButton.addEventListener('click', () => {
                            customPlayers[index].pauseVideo();
                            customPlayButton.style.display = 'inline-block';
                            customPauseButton.style.display = 'none';
                            if (customCurrentPlayerIndex === index) {
                                customCurrentPlayerIndex = null;
                            }
                        });

                        customFullscreenButton.addEventListener('click', () => {
                            customPlayers[index].pauseVideo();
                            customPlayButton.style.display = 'inline-block';
                            customPauseButton.style.display = 'none';
                        });
                    },
                    'onStateChange': function(event) {
                        if (event.data === YT.PlayerState.PLAYING) {
                            customVideoOverlay.classList.add('video__overlay--fadeOut');
                        }
                    }
                }
            });
        });

        // Pausar todos los vídeos cuando se abre Fancybox
        $(document).on('click', '[data-fancybox]', function() {
            customPlayers.forEach(player => player.pauseVideo());
            customCurrentPlayerIndex = null;
        });
    }

    // Verifica si la API ya está cargada
    if (typeof YT !== 'undefined' && YT && YT.Player) {
        initializeYouTubePlayers();
    } else {
        window.onYouTubeIframeAPIReady = function() {
            initializeYouTubePlayers();
        };
    }
})();